import { registerClient } from '@ventanas95dev/runtime/sentry/client'

registerClient()

export { onRouterTransitionStart } from '@ventanas95dev/runtime/sentry/client'
